import '../sass/Banner.scss'
import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCode, faBars, faXmark } from '@fortawesome/free-solid-svg-icons'
function Banner() {
    const [open, setOpen] = useState(false)

    return <header>
        <nav>
            <a href='#name' className='logo' aria-label='Retour en haut de page'><FontAwesomeIcon icon={faCode} size='2xl' style={{color: "#2965FF"}} /></a>
            <button className='burger' onClick={() => setOpen(!open)} aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'}>
                <FontAwesomeIcon icon={open ? faXmark : faBars} size='xl' style={{color: "#8993A1"}} />
            </button>
            <div className={`nav-links ${open ? 'open' : ''}`}>
                <a href='#name' onClick={() => setOpen(false)}><p>ACCUEIL</p></a>
                <a href='#profil' onClick={() => setOpen(false)}><p>PROFIL</p></a>
                <a href='#projects' onClick={() => setOpen(false)}><p>RÉALISATIONS</p></a>
                <a href='#skills' onClick={() => setOpen(false)}><p>COMPÉTENCES</p></a>
                <a href='#timeline' onClick={() => setOpen(false)}><p>EXPÉRIENCES</p></a>
                <a href='#download' onClick={() => setOpen(false)}><p>MON CV</p></a>
                <a href='#contact' onClick={() => setOpen(false)}><p>CONTACT</p></a>
            </div>
        </nav>
    </header>
}
export default Banner